module.exports = __webpack_public_path__ + "static/media/bg-table.f38ab1c1.svg";